export const VOICE_AIRA_LANGUAGES = Object.freeze([
  { code: "en", htmlLang: "en", providerLocale: "en-IN", browserLocale: "en-IN", native: "English", english: "English" },
  { code: "hi", htmlLang: "hi", providerLocale: "hi-IN", browserLocale: "hi-IN", native: "हिन्दी", english: "Hindi" },
  { code: "bn", htmlLang: "bn", providerLocale: "bn-IN", browserLocale: "bn-IN", native: "বাংলা", english: "Bengali" },
  { code: "gu", htmlLang: "gu", providerLocale: "gu-IN", browserLocale: "gu-IN", native: "ગુજરાતી", english: "Gujarati" },
  { code: "kn", htmlLang: "kn", providerLocale: "kn-IN", browserLocale: "kn-IN", native: "ಕನ್ನಡ", english: "Kannada" },
  { code: "ml", htmlLang: "ml", providerLocale: "ml-IN", browserLocale: "ml-IN", native: "മലയാളം", english: "Malayalam" },
  { code: "mr", htmlLang: "mr", providerLocale: "mr-IN", browserLocale: "mr-IN", native: "मराठी", english: "Marathi" },
  { code: "od", htmlLang: "or", providerLocale: "od-IN", browserLocale: "or-IN", native: "ଓଡ଼ିଆ", english: "Odia" },
  { code: "pa", htmlLang: "pa", providerLocale: "pa-IN", browserLocale: "pa-IN", native: "ਪੰਜਾਬੀ", english: "Punjabi" },
  { code: "ta", htmlLang: "ta", providerLocale: "ta-IN", browserLocale: "ta-IN", native: "தமிழ்", english: "Tamil" },
  { code: "te", htmlLang: "te", providerLocale: "te-IN", browserLocale: "te-IN", native: "తెలుగు", english: "Telugu" },
]);

const LANGUAGE_EXAMPLE_COPY = Object.freeze({
  en: [
    ["parent-plan", "Parent meeting", "Parent voice", "Please share the mathematics practice plan for this week.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "Which documents are needed to complete admission?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "Please send the Class 7 revision worksheet by Friday.", "Please send the Class 7 revision worksheet by Friday."],
  ],
  hi: [
    ["parent-plan", "Parent meeting", "Parent voice", "कृपया इस सप्ताह की गणित अभ्यास योजना साझा करें।", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "प्रवेश पूरा करने के लिए कौन-कौन से दस्तावेज़ चाहिए?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "कृपया कक्षा 7 की पुनरावृत्ति कार्यपत्रिका शुक्रवार तक भेजें।", "Please send the Class 7 revision worksheet by Friday."],
  ],
  bn: [
    ["parent-plan", "Parent meeting", "Parent voice", "অনুগ্রহ করে এই সপ্তাহের গণিত অনুশীলনের পরিকল্পনাটি শেয়ার করুন।", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "ভর্তি সম্পূর্ণ করতে কোন কোন নথি লাগবে?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "অনুগ্রহ করে সপ্তম শ্রেণির পুনরাবৃত্তির ওয়ার্কশিটটি শুক্রবারের মধ্যে পাঠান।", "Please send the Class 7 revision worksheet by Friday."],
  ],
  gu: [
    ["parent-plan", "Parent meeting", "Parent voice", "કૃપા કરીને આ અઠવાડિયાની ગણિત અભ્યાસ યોજના શેર કરો.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "પ્રવેશ પૂર્ણ કરવા માટે કયા દસ્તાવેજોની જરૂર છે?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "કૃપા કરીને ધોરણ 7ની પુનરાવર્તન વર્કશીટ શુક્રવાર સુધી મોકલો.", "Please send the Class 7 revision worksheet by Friday."],
  ],
  kn: [
    ["parent-plan", "Parent meeting", "Parent voice", "ದಯವಿಟ್ಟು ಈ ವಾರದ ಗಣಿತ ಅಭ್ಯಾಸ ಯೋಜನೆಯನ್ನು ಹಂಚಿಕೊಳ್ಳಿ.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "ಪ್ರವೇಶವನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಯಾವ ದಾಖಲೆಗಳು ಬೇಕು?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "ದಯವಿಟ್ಟು 7ನೇ ತರಗತಿಯ ಪುನರವಲೋಕನ ಕಾರ್ಯಪತ್ರಿಕೆಯನ್ನು ಶುಕ್ರವಾರದೊಳಗೆ ಕಳುಹಿಸಿ.", "Please send the Class 7 revision worksheet by Friday."],
  ],
  ml: [
    ["parent-plan", "Parent meeting", "Parent voice", "ദയവായി ഈ ആഴ്ചയിലെ ഗണിത പരിശീലന പദ്ധതി പങ്കിടുക.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "പ്രവേശനം പൂർത്തിയാക്കാൻ ഏതെല്ലാം രേഖകളാണ് വേണ്ടത്?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "ദയവായി ഏഴാം ക്ലാസിന്റെ ആവർത്തന വർക്ക്‌ഷീറ്റ് വെള്ളിയാഴ്ചയ്ക്കകം അയയ്ക്കുക.", "Please send the Class 7 revision worksheet by Friday."],
  ],
  mr: [
    ["parent-plan", "Parent meeting", "Parent voice", "कृपया या आठवड्याची गणित सराव योजना शेअर करा.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "प्रवेश प्रक्रिया पूर्ण करण्यासाठी कोणती कागदपत्रे आवश्यक आहेत?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "कृपया इयत्ता 7 ची उजळणी कार्यपत्रिका शुक्रवारपर्यंत पाठवा.", "Please send the Class 7 revision worksheet by Friday."],
  ],
  od: [
    ["parent-plan", "Parent meeting", "Parent voice", "ଦୟାକରି ଏହି ସପ୍ତାହର ଗଣିତ ଅଭ୍ୟାସ ଯୋଜନାଟି ସେୟାର କରନ୍ତୁ।", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "ଆଡମିଶନ ସମ୍ପୂର୍ଣ୍ଣ କରିବା ପାଇଁ କେଉଁ କେଉଁ ଡକ୍ୟୁମେଣ୍ଟ ଦରକାର?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "ଦୟାକରି ସପ୍ତମ ଶ୍ରେଣୀର ପୁନରାବୃତ୍ତି କାର୍ଯ୍ୟପତ୍ର ଶୁକ୍ରବାର ସୁଦ୍ଧା ପଠାନ୍ତୁ।", "Please send the Class 7 revision worksheet by Friday."],
  ],
  pa: [
    ["parent-plan", "Parent meeting", "Parent voice", "ਕਿਰਪਾ ਕਰਕੇ ਇਸ ਹਫ਼ਤੇ ਦੀ ਗਣਿਤ ਅਭਿਆਸ ਯੋਜਨਾ ਸਾਂਝੀ ਕਰੋ।", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "ਦਾਖਲਾ ਪੂਰਾ ਕਰਨ ਲਈ ਕਿਹੜੇ ਦਸਤਾਵੇਜ਼ ਚਾਹੀਦੇ ਹਨ?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "ਕਿਰਪਾ ਕਰਕੇ ਸੱਤਵੀਂ ਜਮਾਤ ਦੀ ਦੁਹਰਾਈ ਵਰਕਸ਼ੀਟ ਸ਼ੁੱਕਰਵਾਰ ਤੱਕ ਭੇਜੋ।", "Please send the Class 7 revision worksheet by Friday."],
  ],
  ta: [
    ["parent-plan", "Parent meeting", "Parent voice", "இந்த வாரத்திற்கான கணிதப் பயிற்சித் திட்டத்தைப் பகிரவும்.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "சேர்க்கையை முடிக்க என்னென்ன ஆவணங்கள் தேவை?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "ஏழாம் வகுப்பு மீள்பார்வைப் பணித்தாளை வெள்ளிக்கிழமைக்குள் அனுப்பவும்.", "Please send the Class 7 revision worksheet by Friday."],
  ],
  te: [
    ["parent-plan", "Parent meeting", "Parent voice", "దయచేసి ఈ వారం గణిత అభ్యాస ప్రణాళికను పంచుకోండి.", "Please share the mathematics practice plan for this week."],
    ["admission-documents", "Admissions", "Family voice", "ప్రవేశాన్ని పూర్తి చేయడానికి ఏ పత్రాలు అవసరం?", "Which documents are needed to complete admission?"],
    ["revision-follow-up", "Staff follow-up", "Coordinator voice", "దయచేసి 7వ తరగతి పునశ్చరణ వర్క్‌షీట్‌ను శుక్రవారం లోపు పంపండి.", "Please send the Class 7 revision worksheet by Friday."],
  ],
});

export const VOICE_AIRA_LANGUAGE_EXAMPLES = Object.freeze(
  VOICE_AIRA_LANGUAGES.map((language) => Object.freeze({
    ...language,
    examples: Object.freeze(LANGUAGE_EXAMPLE_COPY[language.code].map(([
      id, context, speaker, nativeText, englishMeaning,
    ]) => Object.freeze({ id, context, speaker, nativeText, englishMeaning }))),
  })),
);

export function voiceAiraAudioSource(languageCode, exampleId) {
  return `/marketing/voice-aira/audio/v1/${languageCode}-${exampleId}.m4a`;
}

export const VOICE_AIRA_SCENARIOS = Object.freeze([
  {
    id: "parent-teacher",
    tab: "Parent meeting",
    short: "PTM",
    title: "Parent-teacher meeting",
    context: "A concern becomes a shared practice plan",
    language: "Hindi",
    nativeLanguage: "हिन्दी",
    htmlLang: "hi",
    providerLocale: "hi-IN",
    browserLocale: "hi-IN",
    languageChip: "हिन्दी · Hindi detected",
    transcriptLabel: "English transcript from Hindi speech",
    duration: "02:41",
    speaker: "A parent is speaking",
    imageStem: "parent-teacher",
    imageAlt: "Illustration of a teacher and a parent talking across a school meeting table while a phone records with consent.",
    rawParts: [
      { text: "Haan, ", filler: true },
      { text: "but maths… " },
      { text: "uh, ", filler: true },
      { text: "we are, " },
      { text: "you know, ", filler: true },
      { text: "worried" },
    ],
    polished: "The parents are worried about maths and asked how to practise at home.",
    spokenText: "हम गणित को लेकर चिंतित हैं। कृपया बताइए कि घर पर अभ्यास कैसे करें।",
    note: "Maths practice and weekly progress updates were agreed for the next four weeks.",
    actions: ["Share a progress note every Friday", "Practise maths at home twice a week"],
    linkLabel: "Student note · Class 6-B",
  },
  {
    id: "admissions",
    tab: "Admissions",
    short: "Lead call",
    title: "Admissions conversation",
    context: "A family question becomes a clear follow-up",
    language: "Odia",
    nativeLanguage: "ଓଡ଼ିଆ",
    htmlLang: "or",
    providerLocale: "od-IN",
    browserLocale: "or-IN",
    languageChip: "ଓଡ଼ିଆ · Odia detected",
    transcriptLabel: "Native-language transcript",
    duration: "01:18",
    speaker: "A parent is speaking",
    imageStem: "admissions",
    imageAlt: "Illustration of an admissions counsellor speaking with a parent at a welcoming Indian school admissions desk.",
    rawParts: [
      { text: "ଆଡମିଶନ ପାଇଁ… " },
      { text: "ଉମ୍, ", filler: true },
      { text: "କେଉଁ ଡକ୍ୟୁମେଣ୍ଟ ଦରକାର?" },
    ],
    polished: "The family asked which documents are needed to complete admission.",
    spokenText: "ଆଡମିଶନ ପାଇଁ କେଉଁ କେଉଁ ଡକ୍ୟୁମେଣ୍ଟ ଦରକାର?",
    note: "The counsellor will send the document checklist and confirm a campus visit.",
    actions: ["Send the admissions checklist today", "Confirm the campus visit for Saturday"],
    linkLabel: "Admissions lead · Sample family",
  },
  {
    id: "staff-huddle",
    tab: "Staff huddle",
    short: "Staff sync",
    title: "Academic staff huddle",
    context: "A spoken decision becomes owned work",
    language: "Telugu",
    nativeLanguage: "తెలుగు",
    htmlLang: "te",
    providerLocale: "te-IN",
    browserLocale: "te-IN",
    languageChip: "తెలుగు · Telugu detected",
    transcriptLabel: "Native-language transcript",
    duration: "04:06",
    speaker: "The coordinator is speaking",
    imageStem: "staff-huddle",
    imageAlt: "Illustration of a principal and academic coordinator discussing a plan beside an open notebook and recording phone.",
    rawParts: [
      { text: "ఈ వారం… " },
      { text: "ఉమ్, ", filler: true },
      { text: "ఏడో తరగతికి రివిజన్ షీట్ పంపాలి." },
    ],
    polished: "The Class 7 revision worksheet will be shared this week.",
    spokenText: "ఈ వారం ఏడో తరగతికి రివిజన్ షీట్ పంపాలి.",
    note: "The academic team agreed to prepare one revision worksheet for every Class 7 section.",
    actions: ["Coordinator prepares the worksheet", "Class teachers share it by Friday"],
    linkLabel: "Staff note · Academics",
  },
  {
    id: "quick-note",
    tab: "Quick note",
    short: "Voice memo",
    title: "Teacher voice memo",
    context: "A thought after class becomes a useful record",
    language: "English",
    nativeLanguage: "English",
    htmlLang: "en",
    providerLocale: "en-IN",
    browserLocale: "en-IN",
    languageChip: "English · English detected",
    transcriptLabel: "Live transcript",
    duration: "00:36",
    speaker: "A teacher is speaking",
    imageStem: "quick-note",
    imageAlt: "Illustration of a teacher dictating a quick observation into a phone while writing in a notebook after class.",
    rawParts: [
      { text: "Class 7-B… " },
      { text: "um, ", filler: true },
      { text: "needs, " },
      { text: "you know, ", filler: true },
      { text: "a revision sheet by Friday." },
    ],
    polished: "Class 7-B needs a revision worksheet by Friday.",
    spokenText: "Class seven B needs a revision worksheet by Friday.",
    note: "Create a short revision worksheet based on the questions raised after class.",
    actions: ["Draft the worksheet tomorrow", "Share it with Class 7-B by Friday"],
    linkLabel: "Class note · 7-B",
  },
]);

export function voiceAiraSceneSources(stem) {
  const root = `/marketing/voice-aira/v2/${stem}`;
  return {
    src: `${root}.w622.webp`,
    webp: [320, 480, 622].map((width) => `${root}.w${width}.webp ${width}w`).join(", "),
    avif: [320, 480, 622].map((width) => `${root}.w${width}.avif ${width}w`).join(", "),
  };
}
